import { cacheName, cache } from '@/utils/cacheManager'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'

/**
 * 状态查询(配置参数)
 * @param mapKey 缓存中的key值
 * @param stateList 默认值
 * @param dataType 传输的code对象类型Number/String
 * @returns {Promise<Array|*>}
 */
export async function getConfigQueryParam(mapKey, stateList) {
  await cache.load(cacheName.CONFIG)
  const param = cache.config.get(mapKey)
  if (!mapKey || !param) { return [...stateList] }
  const states = param.split(',')
  const result = []
  if (states && states.length > 0) {
    for (let i = 0; i < states.length; i++) {
      const commonState = CommonState.getStateByCode(stateList, Number(states[i]))
      if (commonState) {
        result.push(commonState)
      }
    }
  }
  return result
}

/**
 * 获取默认查询查询
 */
export async function getDefaultOptions(mapKey, fieldName, fieldType) {
  await cache.load(cacheName.CONFIG)
  const value = cache.config.get(mapKey)
  if (!value) return null
  const defaultOptions = new AdvancedSearchOption(null, fieldType)
  const optionValue = getCheckBoxValue(value)
  defaultOptions.fieldName = fieldName
  defaultOptions.value = optionValue
  defaultOptions.locked = (optionValue != null)
  return defaultOptions
}

export function getCheckBoxValue(value) {
  const v = value.split(',')
  if (v.length === 2) {
    return null
  } else {
    return parseInt(v[0]) === 1
  }
}

/**
 * 布尔值查询
 */
export async function getBooleanQueryValue(mapKey) {
  await cache.load(cacheName.CONFIG)
  const value = cache.config.get(mapKey)
  if (!value) { return null }
  const v = value.split(',')
  if (v.length === 2) { return null }
  return v[0]
}

/**
 * 是否已经选择查询内容
 */
export function isSelectOption(conditions, fieldName) {
  let isHas = false
  for (let i = 0; i < conditions.length; i++) {
    if (conditions[i].fieldName === fieldName) {
      isHas = true
      break
    }
  }
  return isHas
}

/** t
 * 查询值转换成int
 */
export function convertCommonStateToInt(list) {
  const queryList = []
  for (const result of list) {
    queryList.push(parseInt(result.code))
  }
  return queryList
}

/**
 * 查询值转换成String
 */
export function convertCommonStateToString(list) {
  const queryList = []
  for (const result of list) {
    queryList.push(String(result.code))
  }
  return queryList
}
